import React from 'react';
import { Provider } from 'react-redux';

import storeFactory from '../store/store';
import { renderReact } from '../utils/reactRoot';

const initialState = window.__INITIAL_STATE__;
const store = storeFactory(initialState);

export const renderReactComponentWithRedux = (WrappedComponent, root, props = null) =>
    renderReact(
        root,
        <Provider store={store}>
            <WrappedComponent { ...props } />
        </Provider>
    );
